__turbopack_context__.v({
  "input": "SearchAutocomplete-module__2X6xSq__input",
  "item": "SearchAutocomplete-module__2X6xSq__item",
  "itemHighlighted": "SearchAutocomplete-module__2X6xSq__itemHighlighted",
  "list": "SearchAutocomplete-module__2X6xSq__list",
  "noResults": "SearchAutocomplete-module__2X6xSq__noResults",
  "resultItemText": "SearchAutocomplete-module__2X6xSq__resultItemText",
  "wrapper": "SearchAutocomplete-module__2X6xSq__wrapper",
});
